import { render } from "./RefundList.vue?vue&type=template&id=3b65357f&scoped=true"
import script from "./RefundList.vue?vue&type=script&lang=js"
export * from "./RefundList.vue?vue&type=script&lang=js"

import "./RefundList.vue?vue&type=style&index=0&id=3b65357f&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b65357f"]])

export default __exports__